import React, { useContext } from "react";

import { Button, Space } from "antd";
import { NavLink } from "react-router-dom";
import { context } from "../../context/context";
import GalleryTable from "./GalleryTable";
const GalletySection = () => {
    // context
    const {
        setGalleryColor,
        setGalleryDescription,
        setGalleryIcon,
        setGalleryMedia,
        setGalleryMediaId,
        setGalleryTags,
        setGalleryTitle,
        setSelectedGalleryId
    } = useContext(context);
    // functions
    const handleEmpty = () => {
        setGalleryMedia([]);
        setGalleryMediaId([]);
        setSelectedGalleryId();
        setGalleryColor();
        setGalleryDescription();
        setGalleryIcon();
        setGalleryTags([]);
        setGalleryTitle();
    };
    return (
        <>
            <Space
                direction="vertical"
                style={{ width: "100%", justifyContent: "space-between" }}
                align="end"
            >
                <NavLink to="/addGallery">
                    <Button onClick={handleEmpty} type="primary">
                        اضافه کردن مورد جدید
                    </Button>
                </NavLink>
            </Space>
            <GalleryTable />
        </>
    );
};

export default GalletySection;
